import React from "react";
import ChartCard from "./ChartCard";
import GridTable from "../../grid-v2/GridTable";

type TableCardProps = {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  className?: string;
  isLoading?: boolean;
  isEmpty?: boolean;
  rows: any[];
  headers: any;
  actions?: Array<{
    label: string;
    content?: React.ReactNode;
    onClick?: (event) => void;
  }>;
  onSetting?: (event) => void;
  onDelete?: (event) => void;
};

const TableCard = ({
  title,
  subtitle,
  className = "",
  isLoading = false,
  isEmpty = false,
  rows,
  headers,
  actions,
  onSetting,
  onDelete,
}: TableCardProps) => {
  return (
    <ChartCard
      title={title}
      subtitle={subtitle}
      className={className}
      isLoading={isLoading}
      actions={actions}
      onSetting={onSetting}
      onDelete={onDelete}
      isEmpty={isEmpty}
    >
      <GridTable headers={headers} rows={rows} />
    </ChartCard>
  );
};

export default TableCard;
